import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { usePermissions } from '@/common/hooks/usePermissions';
import {
  CompanyDocumentsPage,
  type CompanyDocumentsSearch,
} from '@/features/company-documents/components/CompanyDocumentsPage';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const uuid = (v: unknown) => (typeof v === 'string' && UUID.test(v) ? v : undefined);

export const parseCompanyDocumentsSearch = (
  s: Record<string, unknown>,
): CompanyDocumentsSearch => ({
  categoryId: uuid(s.categoryId),
  documentId: uuid(s.documentId),
  view: s.view === 'trash' ? 'trash' : undefined,
});

export const Route = createFileRoute('/_authenticated/company-documents')({
  validateSearch: parseCompanyDocumentsSearch,
  beforeLoad: () => requireFeature('COMPANY_DOCUMENTS'),
  component: CompanyDocumentsRoute,
});

function CompanyDocumentsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  if (!hasPermission('company_documents.view') && !hasPermission('company_documents.manage')) {
    return <Navigate to="/my-dashboard" />;
  }
  return (
    <CompanyDocumentsPage
      search={search}
      onSearchChange={(next) => navigate({ to: '/company-documents', search: next })}
    />
  );
}
